export default __webpack_public_path__ + "1b016c07d46911105f96598e8ac21ea0.png";